<template>
	<div>
		<div class="main" v-if="!isLoading">
			<div>
				<BaseSelect
					class="w-1/3"
					ref="BaseSelect"
					required="true"
					:label="$t('damage_assessor_company')"
					@input="prefill($event)"
					:options="damageAssessorCompanyOptions"
					v-model="selectedDamageAssessorCompany"
					v-if="!isUserAllowedInLevel2"
					:disabled="evaluateDisabled"
					:allow-empty="false"
				/>
				<BaseSelect
					class="w-1/3"
					ref="BaseSelect"
					required="true"
					:label="$t('damage_assessor')"
					v-if="isUserAllowedInLevel2 || (isUserAllowedInLevel1 && !evaluateFields)"
					:options="damageAssessorPersonOptions"
					v-model="selectedDamageAssessorPerson"
					:disabled="!isAuthenticatedUserInGroupAdmin"
					:allow-empty="false"
				/>
				<div v-if="evaluateFields">
					<BaseInput
						ref="BaseInput.model.orga"
						:required="false"
						class="w-full md:w-1/2 pr-0 md:pr-1"
						:label="$t('company_organisation_assessor_office')"
						v-if="selectedDamageAssessorCompany.id === null"
						v-model="damageAssessor.organisation"
						:disabled="evaluateDisabled"
						type="text"
					/>
					<div v-if="model.process_type === 'comprehensive' || model.process_type === 'liability'">
						<PersonNameForm ref="PersonNameForm" v-model="damageAssessor" :disabled="evaluateDisabled" :show-company="false" />

						<AddressInput ref="AddressInput" :disabled="evaluateDisabled" v-model="damageAssessor" />

						<div class="flex flex-wrap">
							<BaseInput
								ref="BaseInput.model.phoneNumber"
								:required="true"
								:disabled="evaluateDisabled"
								class="w-full md:w-1/2 pr-0 md:pr-2"
								:label="$t('phone')"
								v-model="damageAssessor.cellNumber"
								type="tel"
								validationtype="phone"
							/>
							<BaseInput
								:required="true"
								ref="BaseInput.model.email"
								class="w-full md:w-1/2 md:pl-2"
								:label="$t('e_mail')"
								:disabled="evaluateDisabled"
								v-model="damageAssessor.email"
								type="email"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<LoadingSpinner v-else />

		<div class="flex justify-end">
			<BaseButton @click="save" :disabled="isLoading || evaluateDisabled" class="mb-4 btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import { DamageassessorsApiFactory, DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import stateMerge from 'vue-object-merge';
import { getStringFromDate, makeShadowCopy } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';
import PersonNameForm from '@/components/forms/PersonNameForm';
import AddressInput from '@/components/forms/AddressInput';
import BaseInput from '@/components/forms/inputs/BaseInput';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Validate from '@/mixins/Validate';
import DamageAssessorRepository from '@/api/repositories/DamageAssessorRepository';

export default {
	name: 'DamageAssessor',
	components: { BaseSelect, LoadingSpinner, BaseInput, AddressInput, PersonNameForm, BaseButton },
	mixins: [Authentication, Validate],
	data() {
		return {
			model: {
				city: {
					zipCode: null,
					name: null,
				},
			},
			options: [],
			damageAssessor: { city: {} },
			damageAssessorCompanyOptions: [],
			selectedDamageAssessorCompany: null,
			damageAssessorPersonOptions: [],
			selectedDamageAssessorPerson: null,
			damageAssessors: [],
			isLoading: true,
		};
	},
	computed: {
		evaluateFields() {
			return (
				this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0] && (this.isUserAllowedInLevel5or6 || this.isUserAllowedInLevel1)
			);
		},
		evaluateDisabled() {
			if (this.isUserAllowedInLevel2 && !this.isAuthenticatedUserInGroupAdmin) {
				return true;
			}
			if (this.model.damageAssessor && this.model.damageAssessor.system_assessor === false) {
				return true;
			} else {
				if (this.isUserAllowedInLevel5or6) {
					return false; //return this.model.damageAssessorCompany != null;
				}
				return false;
			}
		},
	},
	methods: {
		updateDamageCaseStore() {
			this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) });
		},
		getDamageCaseFromApi() {
			DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdGet(parseInt(this.$route.params.processId || this.$route.params.id))
				.then(response => {
					stateMerge(this.model, response.data);
					this.model = makeShadowCopy(this.model);

					if (this.isUserAllowedInLevel5or6) {
						if (this.model.damageAssessorCompany) {
							this.selectedDamageAssessorCompany = this.damageAssessorCompanyOptions.find(
								document => document.display === this.model.damageAssessorCompany.name,
							);
						} else {
							if (this.model.damageAssessor.system_assessor === false) {
								this.selectedDamageAssessorCompany = this.damageAssessorCompanyOptions[0];
								this.damageAssessor = this.model.damageAssessor;
							}
						}
					} else if (this.isUserAllowedInLevel2 && this.isAuthenticatedUserInGroupAdmin) {
						this.setDamageAssessorOptions();
						this.selectedDamageAssessorPerson = this.damageAssessorPersonOptions.find(person => person.value === this.model.damageAssessor.id);
					} else if (this.isUserAllowedInLevel2 && !this.isAuthenticatedUserInGroupAdmin) {
						this.damageAssessorPersonOptions = [
							{ value: this.model.damageAssessor.id, display: this.model.damageAssessor.firstName + ' ' + this.model.damageAssessor.lastName },
						];
						this.selectedDamageAssessorPerson = this.damageAssessorPersonOptions[0];
					} else if (this.isUserAllowedInLevel1) {
						if (this.model.damageAssessorCompany) {
							this.selectedDamageAssessorCompany = this.damageAssessorCompanyOptions.find(
								document => document.display === this.model.damageAssessorCompany.name,
							);

							this.$nextTick(async () => {
								if (this.selectedDamageAssessorCompany) {
									this.selectedDamageAssessorPerson = null;

									await this.getDamageAssessorsByCompany();
									if (this.model.damageAssessor) {
										this.selectedDamageAssessorPerson = this.damageAssessorPersonOptions.find(
											person => person.value === this.model.damageAssessor.id,
										);
									}
								}
							});
						} else {
							if (this.model.damageAssessor.system_assessor === false) {
								this.selectedDamageAssessorCompany = this.damageAssessorCompanyOptions[0];
								this.damageAssessor = this.model.damageAssessor;
							}
						}
					}
					this.isLoading = false;
				})
				.catch(error => {
					this.isLoading = false;
				});
		},
		save() {
			if (this.validate()) {
				this.isLoading = true;
				if (this.isUserAllowedInLevel2) {
					if (this.isAuthenticatedUserInGroupAdmin) {
						this.selectedDamageAssessorPerson.damage_assessor_id = this.selectedDamageAssessorPerson.id;
						DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
							.damagecasesIdPut(parseInt(this.$route.params.processId || this.$route.params.id), {
								damageAssessor: this.selectedDamageAssessorPerson,
							})
							.then(() => {
								this.updateDamageCaseStore();
								this.$swal({
									title: this.$t('general.success').toString(),
									text: this.$t('assign_assessor_damage_case').toString(),
									icon: 'success',
								}).then(() => this.toProcess());
							})
							.catch(error => {
								this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
							});
					}
				} else if (this.isUserAllowedInLevel1) {
					let request = {};
					if (this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0]) {
						request = {
							damageAssessor: this.damageAssessor,
						};
					} else if (this.selectedDamageAssessorCompany !== null && this.selectedDamageAssessorPerson !== null) {
						this.selectedDamageAssessorPerson.damage_assessor_id = this.selectedDamageAssessorPerson.id;
						request = {
							damageAssessor: this.selectedDamageAssessorPerson,
							damageAssessorCompany: this.selectedDamageAssessorCompany,
						};
					}
					DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.damagecasesIdPut(parseInt(this.$route.params.processId || this.$route.params.id), request)
						.then(() => {
							this.updateDamageCaseStore();
							this.$swal({
								title: this.$t('general.success').toString(),
								text: this.$t('assign_assessor_damage_case').toString(),
								icon: 'success',
							}).then(() => this.toProcess());
						})
						.catch(error => {
							this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
						});
				} else {
					let request = {};
					if (this.selectedDamageAssessorCompany === this.damageAssessorCompanyOptions[0]) {
						request = {
							damageAssessor: this.damageAssessor,
						};
					} else {
						request = {
							damageAssessorCompany: this.selectedDamageAssessorCompany,
						};
					}
					DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.damagecasesIdPut(parseInt(this.$route.params.processId || this.$route.params.id), request)
						.then(() => {
							this.updateDamageCaseStore();
							this.$swal({
								title: this.$t('general.success').toString(),
								text: this.$t('assign_assessor_damage_case').toString(),
								icon: 'success',
							}).then(() => this.toProcess());
						})
						.catch(error => {
							this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
						});
				}
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
		toProcess: function() {
			this.$store.commit('setConfirmLeaving', false);
			this.$router.push({
				name: 'management.process.edit',
				params: {
					processId: parseInt(this.$route.params.processId || this.$route.params.id),
					customer: this.$route.params.customer,
				},
			});
		},
		prefill($event) {
			this.selectedDamageAssessorCompany = $event;
			if ($event) {
				this.damageAssessor = {
					...this.selectedDamageAssessorCompany,
					name: this.selectedDamageAssessorCompany.name,
					city: {
						name: this.selectedDamageAssessorCompany.city.name,
						zipCode: this.selectedDamageAssessorCompany.city.zipCode || '',
					},
				};
			} else {
				this.damageAssessor = {};
			}

			if (this.customSelected) {
				this.validIgnored = [];
			}
		},
		setDamageAssessorOptions() {
			this.damageAssessorPersonOptions = this.options.map(option => {
				option.value = option.person.id;
				option.display = option.person.firstName + ' ' + option.person.lastName;
				return option;
			});
		},
		getDamageAssessorsByCompany() {
			if (!this.selectedDamageAssessorCompany || this.selectedDamageAssessorCompany.id === null) return;
			return DamageAssessorRepository.damageAssessorsOfCompany(this.selectedDamageAssessorCompany.company_id)
				.then(response => {
					this.options = response.data;
					this.setDamageAssessorOptions();
				})
				.catch(error => {
					this.$swal({ title: this.$t('general.attention').toString(), text: error.message });
				});
		},
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6) {
			RepairShopRepository.damageAssessors(RepairShopRepository.repairShopId)
				.then(response => {
					//	this.damageAssessors = response.data.data;
					this.damageAssessorCompanyOptions = response.data.data.map(option => {
						option.value = option.id;
						option.display = option.name;
						return option;
					});
					this.damageAssessorCompanyOptions.unshift({
						id: null,
						name: null,
						display: this.$t('foreign_assessor'),
						highlight: true,
						houseNumber: null,
						street: null,
						poBox: null,
						phoneNumber: null,
						email: null,
						city: {
							zipCode: null,
							name: null,
						},
						isEditable: true,
						highlight_suffix: this.highlight_suffix || null,
					});
				})
				.finally(_ => {
					this.getDamageCaseFromApi();
				});
		} else if (this.isUserAllowedInLevel1) {
			const repairShop = this.$store.state.damageCase.damageCase.repairShop;
			if (repairShop === null) return;
			RepairShopRepository.damageAssessors(this.$store.state.damageCase.damageCase.repairShop.id)
				.then(response => {
					//	this.damageAssessors = response.data.data;
					this.damageAssessorCompanyOptions = response.data.data.map(option => {
						option.value = option.id;
						option.display = option.name;
						return option;
					});
					this.damageAssessorCompanyOptions.unshift({
						id: null,
						name: null,
						display: this.$t('foreign_assessor'),
						highlight: true,
						houseNumber: null,
						street: null,
						poBox: null,
						phoneNumber: null,
						email: null,
						city: {
							zipCode: null,
							name: null,
						},
						isEditable: true,
						highlight_suffix: this.highlight_suffix || null,
					});
				})
				.finally(_ => {
					this.getDamageCaseFromApi();
				});
		} else if (this.isUserAllowedInLevel2 && this.isAuthenticatedUserInGroupAdmin) {
			DamageassessorsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damageassessorsGet(undefined, undefined, this.isUserAllowedInLevel1)
				.then(res => {
					this.options = res.data;
				})
				.catch(error => {})
				.then(_ => {
					this.getDamageCaseFromApi();
				});
		} else if (this.isUserAllowedInLevel2 && !this.isAuthenticatedUserInGroupAdmin) {
			this.getDamageCaseFromApi();
		}
	},
	watch: {
		selectedDamageAssessorCompany: {
			immediate: true,
			async handler(newVal, oldVal) {
				if (!newVal && newVal !== this.damageAssessorCompanyOptions[0] && oldVal === null) return;
				this.selectedDamageAssessorPerson = null;
				this.getDamageAssessorsByCompany(newVal);
			},
		},
	},
};
</script>

<style scoped></style>
